import { Component, Input, OnInit } from '@angular/core';
import { positionInAlphabet } from '@helpers/utilities';

@Component({
  selector: 'app-initials-icon',
  templateUrl: './initials-icon.component.html',
  styleUrls: ['./initials-icon.component.css'],
})
export class InitialsIconComponent implements OnInit {
  @Input()
  size = 1;

  @Input()
  public user: {
    firstName: string;
    lastName: string;
  };

  public iconColor: string;

  public get initials() {
    return this._initials;
  }

  private _initials: { first: string; last: string };

  ngOnInit(){
    this._initials = this.getInitialsForUser();
    this.iconColor = this.setIconColor();
  }

  private setIconColor(): string {
    const positionOfFirstInitialInAlphabet = positionInAlphabet(
      this.initials.first
    );

    let iconColor = '';

    if (positionOfFirstInitialInAlphabet <= 5.2) {
      iconColor = '#729abb';
    } else if (
      positionOfFirstInitialInAlphabet > 5.2 &&
      positionOfFirstInitialInAlphabet <= 10.4
    ) {
      iconColor = '	#60a7cf';
    } else if (
      positionOfFirstInitialInAlphabet > 10.4 &&
      positionOfFirstInitialInAlphabet <= 15.6
    ) {
      iconColor = '#4178b1';
    } else if (
      positionOfFirstInitialInAlphabet > 15.6 &&
      positionOfFirstInitialInAlphabet <= 20.8
    ) {
      iconColor = '#3176a6';
    } else {
      iconColor = '#1b47b5';
    }

    return iconColor;
  }

  private getInitialsForUser() {
    const first = this.getInitial(this.user.firstName);
    const last = this.getInitial(this.user.lastName);

    return { first, last };
  }

  private getInitial(name: string, defaultInitial = '') {
    name = name.trim().toUpperCase();
    return name.length > 0 ? name.charAt(0) : defaultInitial;
  }
}
